import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../services/layout.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  loading: boolean;
  constructor(private loaderService: LayoutService) {
    this.loaderService.isLoading.subscribe((vData) => {
      this.loading = vData;
    });
  }
  ngOnInit() {
  }
}
